import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { TdLoadingService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { TruncateOptions } from 'lodash';

// Application Imports
import { Idea, Category } from '../../shared';
import { IdeaService } from '../../services/idea.service';
import { IdeaCreateDialogComponent } from '../idea-create-dialog/idea-create-dialog.component';
import { YoutubeVideoDialogComponent } from '../youtube-video-dialog/youtube-video-dialog.component';
import { AdminService } from '../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  /**
   * List of ideas
   */
  ideas: Idea[] = [];

  /**
   * List of categories
   */
  categories: Category[] = [];

  /**
   * Truncate options for the title
   */
  titleTruncateOptions: TruncateOptions = { length: 30 };

  /**
   * Truncate options for the description
   */
  descriptionTruncateOptions: TruncateOptions = { length: 100 };
  signersNeededAmount: number;

  /**
   * Constructor
   *
   * @param _router
   * @param _matDialog
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    private _router: Router,
    private _matDialog: MatDialog,
    private _loadingService: TdLoadingService,
    private _ideaService: IdeaService,
    private adminService: AdminService
  ) {}

  /**
   * Init
   */
  ngOnInit() {
    const observables$ = [];

    // Get Ideas
    observables$.push(
      this._ideaService.searchFull({ statusIds: [3, -3] }, { page: 0, size: 3 })
    );
    // Get Categories
    observables$.push(
      this._ideaService.categorySearchWithCounts({ statusIds: this._statuses })
    );

    this._loadingService.register();
    Observable.zip(...observables$)
      .finally(() => {
        this._loadingService.resolve();
      })
      .subscribe((results) => {
        let [res1, res2] = results;

        if (res1['errors']) {
          // console.log(res1);
        } else if (res1['result'].data) {
          this.ideas = res1['result'].data;
        }

        if (res2['errors']) {
          // console.log(res2);
        } else if (res2['result'].data) {
          this.categories = res2['result'].data;
        }
      });
    this.getconfigs();
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }

  /**
   * Returns a list of statuses to filter categories
   */
  private get _statuses() {
    let statuses = [];
    this.statuses.forEach((status) =>
      statuses.push(status.statusId, ...status.includes)
    );
    return statuses;
  }

  isCity(): boolean {
    const clientId = localStorage.getItem('clientId');
    return (
      clientId === '41' || // თბილისი
      clientId === '2723' || // ფოთი
      clientId === '110' || // ქუთაისი
      clientId === '2715' || // ბათუმი
      clientId === '2748' // რუსთავი
    );
  }

  isClient(clientId: number) {
    return clientId === parseInt(localStorage.getItem('clientId'))
  }

  /**
   * List of statuses/tabs
   */
  get statuses() {
    return IdeaService.statuses.filter((status) => !status.profile);
  }

  /**
   * Opens Idea creation dialog
   *
   * @param event
   */
  addIdea(event: Event) {
    this._router.navigate(['/idea-create']);
    // this._matDialog.open(IdeaCreateDialogComponent, { width: '60%' });
  }

  /**
   * Opens youtube video dialog
   *
   * @param event
   */
  playVideo(event: Event) {
    this._matDialog.open(YoutubeVideoDialogComponent, {
      width: '60%',
      panelClass: 'youtube-video'
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/home/home.component.ts